import { Radio as MuiRadio } from '@mui/material'
import { useState } from 'react'

interface RadioProps {
  checked?: boolean
  label: string
  disabled?: boolean
  value: string
  id: string
  onClick: any
  onChange: any
}

export const Radio = (props: RadioProps) => {
  const { checked, disabled, label, value, id, onClick, onChange } = props
  const [_checked, setChecked] = useState<boolean>(checked || false)

  return (
    <div
      className="flex flex-row items-center cursor-pointer"
      onClick={() => onClick(_checked, setChecked)}
    >
      <MuiRadio
        disabled={!!disabled}
        checked={_checked}
        value={value}
        id={id}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          onChange(event)
        }
      />
      <div className="select-none" style={{ fontSize: 14 }}>
        {label}
      </div>
    </div>
  )
}

Radio.defaultProps = {
  defaultChecked: false,
  disabled: false
}
